/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

// var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var modelGet = require('common/util/modelGet');

var BreadcrumbView = require('common/views/BreadcrumbView');
var SideNavSectionView = require('common/views/SideNavSectionView');

var NMLSLabelView = require('../../common/views/NMLSLabelView');
var ContentServerLinkView = require('common/views/ContentServerLinkView');
var LicenseHeaderBarView = require('../../common/views/LicenseHeaderBarView');

var NonDepLicenseBondHistoryView = require('./NonDepLicenseBondHistoryView');
var NonDepLicenseContactHistoryView = require('./NonDepLicenseContactHistoryView');
var NonDepLicenseContactHistoryMigrationView = require('./NonDepLicenseContactHistoryMigrationView');
var NonDepLicenseAddressHistoryView = require('./NonDepLicenseAddressHistoryView');
var NonDepLicenseOfficeManagerHistory = require('./NonDepLicenseOfficeManagerHistoryView');

var tmplNonDepLicenseHistoryView = require('../templates/NonDepLicenseHistoryDashboardView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepLicenseHistoryView,

  className: 'non-dep-license-history-view container-fluid',

  ui: {
    nmlsLabelContainer: '.nmls-label-container',
    csLinkContainer: '.cs-link-container',
    headerBar: '.header-bar-container',
    breadcrumb: '.breadcrumb-container',
    licenseHistory: '.license-history-container'
  },

  regions: {
    nmlsLabelContainer: '@ui.nmlsLabelContainer',
    csLinkContainer: '@ui.csLinkContainer',
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb',
    licenseHistory: '@ui.licenseHistory'
  },

  onBeforeShow: function() {
    var licenseDetails = modelGet(this.model, 'licenseDetails', {});
    var entityId = modelGet(this.model, 'entityId');
    var entityName = licenseDetails.entityName;
    var licenseId = modelGet(this.model, 'licenseId');
    var licenseType = licenseDetails.licenseType;
    var licenseStatus = licenseDetails.licenseStatus;
    var licenseNumber = licenseDetails.licenseNumber;
    var isNMLSLicense = licenseDetails.isNMLSLicense;
    var originalIssueDate = licenseDetails.originalIssueDate;

    if (isNMLSLicense) {
      this.showChildView(
        'nmlsLabelContainer',
        new NMLSLabelView({
          model: new Backbone.Model({
            objectName: 'license'
          })
        })
      );
    }

    this.showChildView(
      'headerBar',
      new LicenseHeaderBarView({
        model: new Backbone.Model({
          title: 'License History',
          licenseType: licenseType,
          licenseStatus: licenseStatus,
          licenseNumber: licenseNumber,
          originalIssueDate: originalIssueDate
        })
      })
    );

    this.showChildView(
      'csLinkContainer',
      new ContentServerLinkView({
        model: new Backbone.Model({
          buttonText: 'Open License Folder',
          contentServerId: modelGet(this.model, 'CSFolderId')
        })
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#nondep/dashboard',
            text: 'Home'
          },
          {
            link: '#nondep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            link: '#nondep/entity/' + entityId + '/license/' + licenseId,
            text: 'License #' + licenseNumber + ' - ' + licenseType
          },
          {
            text: 'History'
          }
        ]
      })
    );

    var sideNavTabs = [
      {
        id: 'licenseBondHistory',
        title: 'Bond History',
        view: new NonDepLicenseBondHistoryView({
          model: new Backbone.Model({
            bondHistory: modelGet(this.model, 'licenseHistory.bondHistory')
          })
        })
      },
      {
        id: 'licenseContactHistory',
        title: 'Contact History',
        view: new NonDepLicenseContactHistoryView({
          model: new Backbone.Model({
            entityId: this.model.get('entityId'),
            licenseId: this.model.get('licenseId'),
            contactHistory: modelGet(this.model, 'licenseHistory.contactHistory')
          })
        })
      },
      {
        id: 'licenseContactHistoryMigration',
        title: 'Contact History Migration',
        view: new NonDepLicenseContactHistoryMigrationView({
          model: new Backbone.Model({
            contactHistoryMigration: modelGet(this.model, 'licenseHistory.contactHistoryMigration')
          })
        })
      },
      {
        id: 'licenseAddressHistory',
        title: 'Address History',
        view: new NonDepLicenseAddressHistoryView({
          model: new Backbone.Model({
            addressHistory: modelGet(this.model, 'licenseHistory.addressHistory')
          })
        })
      },
      {
        id: 'licenseOfficeManagerHistory',
        title: 'Branch Manager History',
        view: new NonDepLicenseOfficeManagerHistory({
          model: new Backbone.Model({
            officeManagerHistory: modelGet(this.model, 'licenseHistory.officeManagerHistory')
          })
        })
      }
    ];

    this.licenseHistory = new SideNavSectionView({
      collection: new Backbone.Collection(sideNavTabs)
    });
    this.showChildView('licenseHistory', this.licenseHistory);
  }
});
